import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ItemSearchDialogComponent } from '../../dialogs/item-search/item-search.dialog';

@Injectable({
  providedIn: 'root'
})
export class ItemSearchDialogService {

    constructor(public dialog: MatDialog) {}

    public open() {
        this.dialog.open(ItemSearchDialogComponent, {
            width: '800px'
        });
    }
}
